/* YAP mobile fixes (Sprint 4, 2026-09-28). Phones only (under 750 px).
   1. Calculators: a live result strip above the inputs, and the typed field scrolls into view above the keyboard.
   2. Any form field on the page scrolls clear of the sticky header and the keyboard when tapped.
   3. Sticky buy bars step aside once the footer is on screen (html.yap-at-foot, styled in yap-polish.css). */
(function () {
  if (window.__yapMobileFix) return; window.__yapMobileFix = true;
  /* A. Supporting white (all screen sizes): walk the page sections in order; when a section's background is the main light
     colour and so is the previous one, paint it white (class yap-alt-white on the element that carries the colour). */
  (function altWhite() {
    var main = document.querySelector('main, #MainContent, .site-main'); if (!main) return;
    var LIGHT = /^rgba?\(242, 244, 241/; // #f2f4f1
    var bodyBg = getComputedStyle(document.body).backgroundColor;
    function carrier(sec) {
      // the element whose background fills the section: the widest, tallest coloured box within 4 levels
      var sr = sec.getBoundingClientRect(), queue = [[sec, 0]];
      while (queue.length) {
        var it = queue.shift(), e = it[0], d = it[1];
        if (e !== sec) {
          var bg = getComputedStyle(e).backgroundColor, r = e.getBoundingClientRect();
          if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent' && r.width >= sr.width * 0.9 && r.height >= sr.height * 0.6) return { el: e, bg: bg };
        }
        if (d < 4) [].forEach.call(e.children, function (k2) { queue.push([k2, d + 1]); });
      }
      var sb = getComputedStyle(sec).backgroundColor;
      return { el: sec, bg: sb && sb !== 'rgba(0, 0, 0, 0)' ? sb : bodyBg };
    }
    var prevLight = false, flip = false;
    main.querySelectorAll(':scope > .shopify-section, :scope > div > .shopify-section').forEach(function (sec) {
      if (/header|footer|announcement|sticky|slideshow/.test(sec.id) || sec.getBoundingClientRect().height < 40) return;
      var c = carrier(sec), light = LIGHT.test(c.bg);
      if (light && prevLight) { flip = !flip; if (flip) { c.el.classList.add('yap-alt-white'); } } else { flip = false; }
      prevLight = light;
    });
  })();

  /* B. GA4 events for the consultation (playbook S4-04), all screen sizes. consultation_click on any link to the booking
     page; generate_lead once a booking or Find Your Robot contact form comes back posted (Shopify adds contact_posted=true). */
  (function consultTracking() {
    function send(name, params, tries) {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; }
      if ((tries || 0) < 12) setTimeout(function () { send(name, params, (tries || 0) + 1); }, 500);
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="schedule-your-professional-consultation"]');
      if (!a) return;
      var where = a.getAttribute('data-yap-consult') || (document.body.className.match(/template-(\w+)/) || [])[1] || 'page';
      // the page unloads before GA4 sends, so remember the tap and report it when the booking page opens
      try { sessionStorage.setItem('yap_consult_click', JSON.stringify({ where: where, from: location.pathname })); } catch (err) { send('consultation_click', { link_location: where, page_path: location.pathname }); }
    }, true);
    if (/schedule-your-professional-consultation/.test(location.pathname)) {
      var pend = null; try { pend = JSON.parse(sessionStorage.getItem('yap_consult_click') || 'null'); sessionStorage.removeItem('yap_consult_click'); } catch (err) {}
      if (pend) send('consultation_click', { link_location: pend.where, page_path: pend.from });
    }
    if (/[?&]contact_posted=true/.test(location.search)) {
      var src = /schedule-your-professional-consultation/.test(location.pathname) ? 'consultation_form' : /find-your-robot/.test(location.pathname) ? 'find_your_robot' : '';
      var key = 'yap_lead_' + location.pathname;
      var seen = false; try { seen = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (err) {}
      if (src && !seen) send('generate_lead', { lead_source: src, page_path: location.pathname });
    }
  })();

  /* C. Sticky add-to-cart bars (playbook S4-02): add Shopify's own monthly quote under the price, e.g. "or from $360.94/mo
     with Shop Pay", read from the Shop Pay Installments banner on the page (never computed here). All screen sizes. */
  (function stickyFinance() {
    var bar = document.querySelector('.yap-sticky, .mw-sticky, .bt-sticky, .wy-sticky'); if (!bar) return;
    function quote() {
      var pt = document.querySelector('shopify-payment-terms'); if (!pt) return '';
      var t = ((pt.shadowRoot ? pt.shadowRoot.textContent : pt.textContent) || '').replace(/\s+/g, ' ');
      var m = t.match(/from (\$[\d,]+(?:\.\d{2})?)\/mo/i); return m ? m[1] : '';
    }
    function priceEl() {
      var els = bar.querySelectorAll('*');
      for (var i = 0; i < els.length; i++) { var e = els[i]; if (!e.children.length && /^\s*(From\s+)?\$[\d,]+(\.\d{2})?\s*$/.test(e.textContent)) return e; }
      return null;
    }
    function render() {
      var q = quote(), p = priceEl(), line = bar.querySelector('.yap-fin');
      if (!q || !p) { if (line) line.remove(); return; }
      if (!line) { line = document.createElement('span'); line.className = 'yap-fin'; p.insertAdjacentElement('afterend', line); }
      line.textContent = 'or from ' + q + '/mo with Shop Pay';
    }
    render(); setTimeout(render, 1500); setTimeout(render, 4000);
    document.addEventListener('change', function () { setTimeout(render, 900); });
  })();

  var mq = window.matchMedia('(max-width: 749px)');
  var tablet = window.matchMedia('(max-width: 989px)').matches;
  if (!tablet) return;
  var root = document.documentElement;

  function headerBottom() {
    var bar = document.getElementById('yap-mob-bar');
    if (bar) { var r = bar.getBoundingClientRect(); if (r.height && r.bottom > 0) return r.bottom; }
    return 64;
  }
  function viewH() { return window.visualViewport ? window.visualViewport.height : window.innerHeight; }
  function bringIntoView(el) {
    var r = el.getBoundingClientRect(), top = headerBottom() + 10;
    if (r.top >= top && r.bottom <= viewH() - 16) return; // already clear of header and keyboard
    window.scrollTo({ top: window.pageYOffset + r.top - top, behavior: 'smooth' });
  }

  /* 1. Calculators */
  var calcs = [
    { root: '[data-yfh-calc]', before: '.yfh__in', s: '[data-yfh-s]', r: '[data-yfh-r]', be: '[data-yfh-be]', name: '[data-yfh-rname]' },
    { root: '[data-yf-calc]', before: '.yf__calc-in', inside: true, s: '[data-yf-s]', r: '[data-yf-r]', be: '[data-yf-be]', select: '[data-yf-robot]' }
  ];
  if (mq.matches) calcs.forEach(function (c) {
    document.querySelectorAll(c.root).forEach(function (box) {
      var anchor = box.querySelector(c.before); if (!anchor) return;
      var live = document.createElement('div');
      live.className = 'yap-calc-live'; live.setAttribute('aria-hidden', 'true'); // the section's own result is already announced
      if (c.inside) anchor.insertBefore(live, anchor.firstChild); else anchor.parentNode.insertBefore(live, anchor);
      function txt(sel) { var e = box.querySelector(sel); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
      function update() {
        var s = txt(c.s), r = txt(c.r), be = txt(c.be), has = /\$[1-9]/.test(s);
        var robot = 'Robot';
        if (c.name) robot = txt(c.name) || robot;
        if (c.select) { var sel = box.querySelector(c.select); if (sel && sel.selectedIndex > -1) robot = sel.options[sel.selectedIndex].text.split(' (')[0]; }
        live.innerHTML = '';
        if (!has) { live.textContent = 'Type your costs below. Your 5-year total shows here as you type.'; return; }
        var a = document.createElement('span'); a.innerHTML = 'Lawn service, 5 years: <b></b>'; a.querySelector('b').textContent = s;
        var b = document.createElement('span'); b.innerHTML = 'Robot: <b></b>'; b.querySelector('b').textContent = r;
        live.appendChild(a); live.appendChild(b);
        if (be && !/^Type your/.test(be)) { var d = document.createElement('span'); d.className = 'yap-calc-live__be'; d.textContent = /pays for itself/i.test(be) ? be : 'Pays for itself in about ' + be; live.appendChild(d); }
        live.title = robot;
      }
      function later() { window.requestAnimationFrame(update); }
      box.addEventListener('input', later); box.addEventListener('change', later);
      box.addEventListener('focusin', function (e) {
        if (!e.target.matches('input, select')) return;
        setTimeout(function () { bringIntoView(live); }, 350);
      });
      update(); setTimeout(update, 800); setTimeout(update, 2500); // the price arrives by fetch
    });
  });

  /* 2. Other form fields: keep the tapped field visible above the keyboard */
  document.addEventListener('focusin', function (e) {
    if (!mq.matches) return;
    var t = e.target;
    if (!t.matches || !t.matches('main input:not([type=checkbox]):not([type=radio]):not([type=hidden]), main textarea, main select')) return;
    if (t.closest('[data-yfh-calc], [data-yf-calc]')) return;
    setTimeout(function () { bringIntoView(t); }, 350);
  });

  /* 4. Product rows as swipe carousels with dots (styles in yap-polish.css): homepage collection rows, "Shop the ... system"
     and "You recently viewed". Empire's Flickity may start later and move the cards into its slider, so the scroller and cards
     are looked up each time. Rows are set up at load, when the theme editor reloads a section, and when recently viewed fills in. */
  var ROWS = '.featured-collection__content, .product-recently-viewed__content';
  var rowsMq = window.matchMedia('(max-width: 719px)');
  function rowItems(row) { var sl = row.querySelector('.flickity-slider'); return sl ? [].slice.call(sl.children) : [].slice.call(row.querySelectorAll('.productgrid--item')); }
  function initRow(row) {
    if (!rowsMq.matches || row.__yapDots) return;
    var items = rowItems(row); if (items.length < 2) return;
    row.__yapDots = true;
    // keep Flickity's drag from fighting the native swipe: it listens on its viewport, so stop presses at the scroller below it
    function guard(el) { if (el.__yapGuard) return; el.__yapGuard = true; ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) { el.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true }); }); }
    function scroller() { var sc = row.querySelector('.flickity-slider') || row; guard(sc); return sc; }
    scroller();
    if ('MutationObserver' in window) new MutationObserver(function () { scroller(); }).observe(row, { childList: true });
    var old = row.parentNode.querySelector(':scope > .yap-fc-dots'); if (old) old.remove();
    var dots = document.createElement('div'); dots.className = 'yap-fc-dots'; dots.setAttribute('role', 'group');
    var sec = row.closest('.shopify-section'), title = sec && sec.querySelector('.home-section--title, .product-recently-viewed__heading');
    dots.setAttribute('aria-label', (title ? title.textContent.trim() + ': ' : '') + items.length + ' products');
    items.forEach(function (it, i) {
      var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Show product ' + (i + 1) + ' of ' + items.length);
      d.addEventListener('click', function () { var sc = scroller(), el = rowItems(row)[i]; if (el) sc.scrollTo({ left: el.offsetLeft - sc.offsetLeft - 16, behavior: 'smooth' }); });
      dots.appendChild(d);
    });
    row.parentNode.insertBefore(dots, row.nextSibling);
    var cur = -1;
    function mark() {
      var sc = scroller(), list = rowItems(row), first = list[0]; if (!first) return;
      var step = first.getBoundingClientRect().width + 12, k = Math.max(0, Math.min(list.length - 1, Math.round(sc.scrollLeft / step)));
      if (sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4) k = list.length - 1;
      if (k === cur) return; cur = k;
      dots.querySelectorAll('button').forEach(function (b, x) { b.setAttribute('aria-current', x === k ? 'true' : 'false'); });
    }
    var ticking = false;
    document.addEventListener('scroll', function (e) { if (e.target !== scroller() || ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; mark(); }); }, true);
    mark();
  }
  function scanRows(scope) { (scope || document).querySelectorAll(ROWS).forEach(initRow); }
  scanRows();
  document.addEventListener('shopify:section:load', function (e) { scanRows(e.target); });
  window.addEventListener('load', function () { scanRows(); });
  var rv = document.querySelector('.product-recently-viewed--section');
  if (rv && 'MutationObserver' in window) new MutationObserver(function () { scanRows(rv); }).observe(rv, { childList: true, subtree: true });

  /* 5. Brand panels (homepage "Chosen for large properties."): phones have no hover, so while the section is on screen
     the brands open one after another like a showcase. The track keeps the same height (one open card + slim bars),
     so nothing below moves. A tap pauses the autoplay for 8 s and opens that brand (tap handling is in yap-motion.js). */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.ybp-track').forEach(function (track) {
      var panels = [].slice.call(track.querySelectorAll('.ybp-panel')); if (panels.length < 2) return;
      var DWELL = 4500, timer = null, stopped = false, inView = false;
      function activate(p) { panels.forEach(function (x) { var on = x === p; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
      function bar() { track.classList.remove('is-auto'); void track.offsetWidth; track.classList.add('is-auto'); }
      function next() { var i = panels.findIndex(function (p) { return p.classList.contains('is-active'); }); activate(panels[(i + 1) % panels.length]); bar(); }
      function start() { if (stopped || timer) return; bar(); timer = setInterval(next, DWELL); }
      function stop() { clearInterval(timer); timer = null; track.classList.remove('is-auto'); }
      new IntersectionObserver(function (es) { es.forEach(function (e) { inView = e.isIntersecting; if (inView) start(); else stop(); }); }, { threshold: 0.35 }).observe(track);
      var resume = null; /* a tap pauses the showcase; it starts again after 8 s without taps (owner, 2026-09-29) */
      ['click', 'keydown'].forEach(function (t) { track.addEventListener(t, function () { stopped = true; stop(); clearTimeout(resume); resume = setTimeout(function () { stopped = false; if (inView && !document.hidden) start(); }, 8000); }); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (inView) start(); });
    });
  }

  /* 7. Mowrator edition bar (24, 37, 40, 50 degrees): a gold bar glides to the current edition as you scroll the chapters,
     and when the bar is wider than the screen it slides sideways to keep the current edition centred. */
  document.querySelectorAll('.mw-show__navin').forEach(function (nav) {
    var glide = document.createElement('span'); glide.className = 'yap-glide'; glide.setAttribute('aria-hidden', 'true');
    nav.style.position = 'relative'; nav.appendChild(glide);
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function move() {
      var t = nav.querySelector('.mw-show__tab.is-on') || nav.querySelector('.mw-show__tab'); if (!t) return;
      glide.style.width = t.offsetWidth + 'px'; glide.style.top = (t.offsetTop + t.offsetHeight - 3) + 'px'; glide.style.transform = 'translateX(' + t.offsetLeft + 'px)';
      if (nav.scrollWidth > nav.clientWidth + 2) nav.scrollTo({ left: t.offsetLeft - (nav.clientWidth - t.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
    }
    new MutationObserver(move).observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', move); move(); setTimeout(move, 800);
  });

  /* 8. Long text on phones: a 4-line preview and "Read more" (owner: too much to read). Nothing is removed; FAQs, spec sheets,
     blog posts, product description tabs and forms are left fully open. */
  if (mq.matches) {
    var SKIP = '[class*=faq], .article--content, .rte, .yi-qa, [class*=spec], [class*=sheet], details, .ypt__panel, form, .shopify-policy__body, .yap-calc-live, [class*=hotspot]';
    var NOT_BODY = /kicker|eyebrow|note|hint|tag|price|badge|lede|lead|kick|small|meta|sub|caption/;
    document.querySelectorAll('.mw, .bt, .wy, .hb, .yap-section, .yb, .ymf, .mhs').forEach(function (root) {
      root.querySelectorAll('p').forEach(function (p) {
        if (p.__yapRm || p.closest(SKIP) || NOT_BODY.test(p.className)) return;
        var group = [p], n = p.nextElementSibling;
        while (n && n.tagName === 'P' && !NOT_BODY.test(n.className)) { group.push(n); n = n.nextElementSibling; }
        group.forEach(function (x) { x.__yapRm = true; });
        var len = group.reduce(function (s, x) { return s + x.textContent.trim().length; }, 0);
        if (len < 300) return;
        p.classList.add('yap-rm-first'); group.slice(1).forEach(function (x) { x.classList.add('yap-rm-more'); });
        if (group.length === 1 && p.scrollHeight <= p.clientHeight + 2) { p.classList.remove('yap-rm-first'); return; } // fits in 4 lines
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'yap-rm-btn'; btn.textContent = 'Read more'; btn.setAttribute('aria-expanded', 'false');
        group[group.length - 1].insertAdjacentElement('afterend', btn);
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false'); btn.textContent = open ? 'Show less' : 'Read more';
          group.forEach(function (x) { x.classList.toggle('is-open', open); });
          if (!open) { var r = p.getBoundingClientRect(); if (r.top < 60) window.scrollBy({ top: r.top - 80, behavior: 'smooth' }); }
        });
      });
    });
  }

  /* 9. Carousel rows that Empire's Flickity builds after load (recently viewed): stop its drag so the native swipe works. */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (window.matchMedia('(max-width: 719px)').matches && e.target.closest && e.target.closest('.product-recently-viewed__content .flickity-slider')) e.stopPropagation();
    }, { capture: true, passive: true });
  });

  /* 10. Chat as a full-screen sheet on phones, sized to the visible screen so the typing box sits above the keyboard. */
  var chatPanel = document.getElementById('yap-chat-panel');
  if (chatPanel && mq.matches) {
    var vv = window.visualViewport;
    var fullH = window.innerHeight;
    var fit = function () { var h = vv ? vv.height : window.innerHeight, t = vv ? vv.offsetTop : 0; fullH = Math.max(fullH, window.innerHeight); root.style.setProperty('--yap-vvh', Math.round(h) + 'px'); root.style.setProperty('--yap-vvt', Math.round(t) + 'px'); root.classList.toggle('yap-kb', h < fullH * 0.75); };
    var sync = function () { var open = chatPanel.classList.contains('yap-open'); root.classList.toggle('yap-chat-open', open); if (open) fit(); };
    new MutationObserver(sync).observe(chatPanel, { attributes: true, attributeFilter: ['class'] });
    if (vv) {
      vv.addEventListener('resize', function () { if (root.classList.contains('yap-chat-open')) fit(); });
      vv.addEventListener('scroll', function () { if (root.classList.contains('yap-chat-open')) fit(); });
    }
    sync();
  }

  /* 11. Product cards: a "Details" link under the price (owner reference card). Added at load and whenever cards appear
     (carousels, recently viewed, filters). */
  function addDetails(scope) {
    (scope || document).querySelectorAll('.productitem').forEach(function (card) {
      if (card.querySelector('.yap-details')) return;
      var link = card.querySelector('.productitem--title a, a.productitem--image-link'), info = card.querySelector('.productitem--info');
      if (!link || !info) return;
      var a = document.createElement('a'); a.className = 'yap-details'; a.href = link.getAttribute('href'); a.textContent = 'Details';
      var t = card.querySelector('.productitem--title'); a.setAttribute('aria-label', 'Details: ' + (t ? t.textContent.trim() : 'product'));
      info.appendChild(a);
    });
  }
  if (mq.matches) {
    addDetails();
    if ('MutationObserver' in window) {
      var cardTimer = null;
      new MutationObserver(function () { clearTimeout(cardTimer); cardTimer = setTimeout(function () { addDetails(); }, 150); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* 3. Sticky bars off at the footer */
  var foot = document.querySelector('.site-footer-wrapper, footer.site-footer, #shopify-section-footer, [id$="__footer"]');
  if (foot && mq.matches && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (en) { root.classList.toggle('yap-at-foot', en.isIntersecting); }); }).observe(foot);
  }
})();
